import { useCallback, useEffect, useRef } from 'react';
import isBrowser from '../utils/isBrowser';
var useModalA11y = function (_a) {
    var visible = _a.visible, onClose = _a.onClose;
    var afterRef = useRef(null);
    var beforeRef = useRef(null);
    var dialogRef = useRef(null);
    // Close modal on escape press when open
    var handleKeyup = useCallback(function (event) {
        if (visible) {
            var key = event.key;
            if (key === 'Escape') {
                onClose();
            }
        }
    }, [visible, onClose]);
    // Trap focus within modal when open
    var handleBlur = useCallback(function (event) {
        if (visible) {
            var focusableChildren = dialogRef.current.querySelectorAll('a[href], button, input, textarea, select, details, iframe, [tabindex]:not([tabindex="-1"])');
            var firstFocusableChild = focusableChildren[0];
            var lastFocusableChild = focusableChildren[focusableChildren.length - 1];
            var relatedTarget = event.relatedTarget;
            if (relatedTarget === beforeRef.current) {
                lastFocusableChild === null || lastFocusableChild === void 0 ? void 0 : lastFocusableChild.focus();
            }
            if (relatedTarget === afterRef.current) {
                firstFocusableChild === null || firstFocusableChild === void 0 ? void 0 : firstFocusableChild.focus();
            }
        }
    }, [visible]);
    useEffect(function () {
        if (isBrowser()) {
            document.body.addEventListener('blur', handleBlur, true);
            document.body.addEventListener('keyup', handleKeyup);
        }
        return function () {
            if (isBrowser()) {
                document.body.removeEventListener('blur', handleBlur, true);
                document.body.removeEventListener('keyup', handleKeyup);
            }
        };
    }, [handleBlur, handleKeyup]);
    useEffect(function () {
        var previouslyFocusedElement = document.querySelector('[data-ocm-refocus="true"]');
        if (visible) {
            // Cache previously focused element before modal was opened to return focus once modal is closed
            if (!previouslyFocusedElement) {
                document.activeElement.setAttribute('data-ocm-refocus', 'true');
                setTimeout(function () {
                    var _a;
                    (_a = dialogRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                }, 100);
            }
        }
        else {
            if (previouslyFocusedElement) {
                previouslyFocusedElement.focus();
                previouslyFocusedElement.removeAttribute('data-ocm-refocus');
            }
        }
    }, [visible]);
    return {
        afterRef: afterRef,
        beforeRef: beforeRef,
        dialogRef: dialogRef,
    };
};
export default useModalA11y;
